import { useHasPermission } from '@app/core/auth/authorization';
import { auditReportsPermissions } from '@app/modules/audit/audit-reports-permissions';
import AddIcon from '@mui/icons-material/Add';
import { Box, Button } from '@mui/material';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { aodRoutes } from '../../routing/routes';

export function CreateRuleButton() {
  const { $t } = useIntl();
  const hasPermission = useHasPermission(auditReportsPermissions.AodRules_Manage);

  if (!hasPermission) {
    return null;
  }

  return (
    <Box display="flex">
      <Button
        component={Link}
        to={aodRoutes.ruleAdd.gen()}
        size="small"
        variant="outlined"
        startIcon={<AddIcon />}
      >
        {$t({
          id: 'audit.aod.rules.add',
          defaultMessage: 'Crear regla',
        })}
      </Button>
    </Box>
  );
}
